import styled from 'styled-components';

import { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';

import COLORS from '@ui-component-library/styles/colors';
import { TOOLTIP_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Wrapper: styled.div`
    ${TOOLTIP_RESET}

    display: inline-flex;
    align-items: center;
    cursor: help;

    &:focus-visible {
      outline: 2px solid ${COLORS['charcoal-500']};
      outline-offset: 2px;
      border-radius: 4px;
    }

    &:focus:not(:focus-visible) {
      outline: none;
    }
  `,

  TooltipContent: styled.div<{
    $isVisible: boolean;
    $position: { top: number; left: number };
  }>`
    ${TYPOGRAPHY.labelXtraSmallRegular}
    position: ${(props) => (props.$isVisible ? 'fixed' : '')};
    top: ${(props) => props.$position.top}px;
    left: ${(props) => props.$position.left}px;

    color: ${COLORS['white-50']};
    background-color: ${COLORS['charcoal-500']};
    border: 1px solid ${COLORS['charcoal-425']};
    padding: ${SPACING.size8} ${SPACING.size12};
    border-radius: 8px;
    max-width: 290px;
    z-index: 1060; /* Temporary big number cause of overlapping vb-example components */

    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 12px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid ${COLORS['charcoal-500']};
    }
  `
};
